export default {
  nav: null,
  errors: [],
  refreshKey: 0,
  activities: {
    rootID: null,
    byID: {},
    allIDs: [],
    idsBy: {
      equipmentID: {},
      parentID: {},
      routineID: {},
      goalID: {},
    },
  },
  equipments: {
    byID: {},
    allIDs: [],
    idsBy: {
      activityID: {},
    },
  },
  trips: {
    byID: {},
    allIDs: [],
  },
  diaryposts: {
    byID: {},
    allIDs: [],
  },
  routines: {
    byID: {},
    allIDs: [],
    idsBy: {
      activityID: {},
    },
  },
  goals: {
    byID: {},
    allIDs: [],
    idsBy: {
      taskID: {},
      activityID: {},
    },
  },
  tasks: {
    byID: {},
    allIDs: [],
    idsBy: {
      goalID: {},
    },
  },
};
